import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CalltoactionService} from '@irb-common/components/calltoaction/calltoaction.service';
import {FiltersForGridService} from '@irb-common/components/filters-for-grid/filters-for-grid.service';
import {UtilityService} from '@irb-common/services/utility.service';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
  selector: 'irb-filters-for-grid',
  templateUrl: './filters-for-grid.component.html',
  styleUrls: ['./filters-for-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FiltersForGridComponent implements OnInit {

  @ViewChild('IrbGridFiltersDropdown') irbGridFiltersDropdown: any;
  @ViewChild('NewUpdateFilterNameTxt') newUpdateFilterNameTxt: any;

  setAsDefault: boolean = false;
  listOfFiltersForDD: Array<any> = [];
  selectedGridFiltersValue: any;
  disableManageButton: boolean = true;
  newUpdateFilterName: string = '';
  disabledSaveBtn: boolean = false;
  setAsDefaultOnSaveChk: boolean = false;
  setAsDefaultDisabled: boolean = false;

  listOfFilters: Array<any> = [];
  // @Input() listOfFilters: Array<any> = [];
  @Input() parentComponentParams: any;
  @Input() filterForGrid: string;
  @Input() applyDefault: boolean = true;
  @Output() applySelectedGridFilter = new EventEmitter<any>();


  constructor(private ctas: CalltoactionService, private filtersForGridService: FiltersForGridService, private util: UtilityService, private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    const noFilter: any = {filterName: '-No saved filter applied-', filterId: -1, default: false, system: false, filterModel: {}};
    this.listOfFilters.push(noFilter);

    this.filtersForGridService.getPresetFilters(this.filterForGrid).subscribe((resp: any) => {
      if (resp.responseStatus === 'SUCCESS') {
        let defaultPresent = false;
        let filters: any = resp.responseData;
        if (filters && filters.length !== 0) {
          filters.forEach((f:any) => {
            if (f.default)
                defaultPresent = true;
            if (f.filterModel && typeof f.filterModel === 'string')
              f.filterModel = JSON.parse(f.filterModel);
          });
        }
        this.listOfFilters = this.listOfFilters.concat(filters);
        this.selectedGridFiltersValue = {name: noFilter.filterName, value: noFilter.filterId};
        if (this.listOfFilters.length > 1) {
          if (this.applyDefault) {
            this.setSelectedItem();
          } else {
            this.selectedGridFiltersValue = {name: noFilter.filterName, value: noFilter.filterId};
          }
          this.getDropDownList();
        }
        if (defaultPresent && this.applyDefault)
            this.onFilterChange();
        else
            this.setAsDefault = false;
      } else {
        this.selectedGridFiltersValue = {name: noFilter.filterName, value: noFilter.filterId};
        this.getDropDownList();
        this.setAsDefault = false;
      }
      this.cdr.detectChanges();
    });
  }

  private setAsDefaultChkDisabled() {
    this.setAsDefaultDisabled = this.selectedGridFiltersValue.value === -1;

    if (this.selectedGridFiltersValue.value === -1) {
      this.setAsDefault = false;
    } else {
      this.setAsDefault = this.listOfFilters.find(f => f.default === true && f.filterId === this.selectedGridFiltersValue.value) ? true : false;
    }
  }

  private setSelectedItem() {
    for (let i = 0; i < this.listOfFilters.length; i++) {
      if (this.listOfFilters[i].default) {
        this.selectedGridFiltersValue = {name: this.listOfFilters[i].filterName, value: this.listOfFilters[i].filterId};
        this.getNewUpdateFilterName();
        break;
      }
    }
  }

  public getNewUpdateFilterName () {
    this.newUpdateFilterName = !this.selectedGridFiltersValue || (this.selectedGridFiltersValue && this.selectedGridFiltersValue.value === -1) ? '' : this.selectedGridFiltersValue.name;
    this.setAsDefaultOnSaveChk = false;
    if (this.newUpdateFilterName !== '' && this.selectedGridFiltersValue && this.selectedGridFiltersValue.value !== -1) {
      const filterFromList = this.listOfFilters.find(f => f.filterId === this.selectedGridFiltersValue.value);
      this.setAsDefaultOnSaveChk = filterFromList && filterFromList.default;
    }
  }

  getDropDownList() {
    this.listOfFiltersForDD = [];
    let ddItem: any;

    for(let i = 1; i < this.listOfFilters.length; i++) {
      ddItem = {name: this.listOfFilters[i].filterName, value: this.listOfFilters[i].filterId};
      this.listOfFiltersForDD.push(ddItem);
    }
    this.listOfFiltersForDD = this.util.sortByKey(this.listOfFiltersForDD, "name", "asc");
    ddItem = {name: this.listOfFilters[0].filterName, value: this.listOfFilters[0].filterId};
    this.listOfFiltersForDD.unshift(ddItem);
  }

  getGridFilters(searchStr: string) {
    const f = DropdownFilterComponent.getFilteredList( searchStr, this.listOfFiltersForDD);
    this.irbGridFiltersDropdown.set(f);
  }


  onFilterChange() {
    if (!this.selectedGridFiltersValue) {
      return;
    }
    const fltr = this.listOfFilters.find(f => f.filterId === this.selectedGridFiltersValue.value);
    if (fltr) {
      this.applySelectedGridFilter.emit(fltr.filterModel);
    } else {
      this.applySelectedGridFilter.emit(null);
    }
    this.getNewUpdateFilterName();
    this.setAsDefaultChkDisabled();
    this.cdr.detectChanges();
  }

  setToNoFilter() {
    if (this.selectedGridFiltersValue && this.selectedGridFiltersValue.value !== -1) {
      this.selectedGridFiltersValue = this.listOfFiltersForDD.find(f => f.value === -1);
    }
    if (!this.selectedGridFiltersValue) {
      this.selectedGridFiltersValue = {name: this.listOfFilters[0].filterName, value: this.listOfFilters[0].filterId};
    }
    this.newUpdateFilterName = '';
    this.setAsDefaultChkDisabled();
    this.cdr.detectChanges();
  }

  cancelDelete() {
    this.ctas.remove();
  }

  proceedWithDelete() {
    let idx:number = null;
    for(let i=0; i < this.listOfFilters.length; i++) {
      if (this.listOfFilters[i].filterId === this.selectedGridFiltersValue.value && this.selectedGridFiltersValue.value !== -1) {
        idx = i;
        break;
      }
    }
    if (idx !== null) {
      this.filtersForGridService.deletePresetFilter(this.selectedGridFiltersValue.value, this.filterForGrid).subscribe(() => {
      });
      this.listOfFilters.splice(idx, 1);
      const res = this.listOfFilters.find(f => f.default === true);
      if (!res) {
        this.listOfFilters[0].default = true;
      }

      this.setSelectedItem();
      this.getDropDownList();

      this.applySelectedGridFilter.emit(null);

    }
    this.setAsDefaultChkDisabled();
    this.cancelDelete();
  }

  saveAndApply() {
    if (this.parentComponentParams && this.parentComponentParams.parentObject) {
      if (typeof this.parentComponentParams.parentObject.getCurrentFilterModel === 'function') {
        const newFilterModel = this.parentComponentParams.parentObject.getCurrentFilterModel();
        let newUpdatedFilter: any = {
          filterName: this.newUpdateFilterName,
          default: this.setAsDefault,
          system: false,
          filterModel: newFilterModel
        };

        if (this.setAsDefault) {
          this.listOfFilters.forEach((f:any) => {
            f.default = false;
          });
        }

        if (this.selectedGridFiltersValue.value !== -1) { // update filter
          newUpdatedFilter.filterId = this.selectedGridFiltersValue.value;
          this.listOfFilters.forEach((f:any) => {
            if (f.filterId === newUpdatedFilter.filterId) {
              f.filterName = newUpdatedFilter.filterName;
              f.filterModel = newUpdatedFilter.filterModel;
              f.default = this.setAsDefault;
            }
          });
          this.listOfFiltersForDD.forEach((f:any) => {
            if (f.value === newUpdatedFilter.filterId) {
              f.name = newUpdatedFilter.filterName;
              this.selectedGridFiltersValue.name = newUpdatedFilter.filterName;
            }
          });

          this.filtersForGridService.updatePresetFilters(newUpdatedFilter, this.filterForGrid).subscribe(() => {
            this.setAsDefaultChkDisabled();
            this.cancelDelete();
          });

        } else { // new filter
          newUpdatedFilter.filterId = null;
          this.filtersForGridService.updatePresetFilters(newUpdatedFilter, this.filterForGrid).subscribe((resp: any) => {
            if (resp.responseStatus === 'SUCCESS') {
              newUpdatedFilter = resp.responseData;
              if (typeof newUpdatedFilter.filterModel === 'string')
                newUpdatedFilter.filterModel = JSON.parse(newUpdatedFilter.filterModel);
            }
            this.listOfFilters.push(newUpdatedFilter);
            this.selectedGridFiltersValue = {name: newUpdatedFilter.filterName, value: newUpdatedFilter.filterId};
            this.listOfFiltersForDD.push(this.selectedGridFiltersValue);

            this.setAsDefaultChkDisabled();
            this.cancelDelete();
          });
        }
        const l = [].concat(this.listOfFiltersForDD);
        this.irbGridFiltersDropdown.set(l);
        this.irbGridFiltersDropdown.setInputValue();
      }
    }


    let listOfFiltersForDDUnsorted = this.listOfFiltersForDD.filter((f: any) => {return f.value !== -1});
    listOfFiltersForDDUnsorted= this.util.sortByKey(listOfFiltersForDDUnsorted, "name", "asc");
    const ddItem = {name: this.listOfFilters[0].filterName, value: this.listOfFilters[0].filterId};
    listOfFiltersForDDUnsorted.unshift(ddItem);
    this.listOfFiltersForDD = listOfFiltersForDDUnsorted;
  }

  validateSaveButton(event?: any) {
    const newFilterName = event || '';
    this.disabledSaveBtn = newFilterName === '' || (this.newUpdateFilterNameTxt && this.newUpdateFilterNameTxt.inputControl && !this.newUpdateFilterNameTxt.inputControl.valid);
  }
  handleGridFilterChanges(filterCriteria: string) {
      this.disableManageButton = filterCriteria === '';
      if (this.selectedGridFiltersValue && this.listOfFiltersForDD && this.listOfFiltersForDD.length > 10 && this.selectedGridFiltersValue.value === -1) {
          this.disableManageButton = true;
      }
      if (filterCriteria === '') {
          this.setToNoFilter();
      }
      this.cdr.detectChanges();
  }

}
